<template>
  <v-container class="experience-section" id="experience" v-resize="onWindowResize">
    <p class="section-title">experience</p>
    <v-layout>
      <v-timeline :dense="dense">
        <v-timeline-item v-for="event in timelineData" :key="event.date" :color="'black'" small>
          <template v-slot:opposite>
            <span v-text="event.date"></span>
          </template>
          <v-card>
            <v-card-title class="headline">{{ event.title }}</v-card-title>
            <v-card-text class="event-header" v-if="event.header">{{ event.header }}</v-card-text>
            <v-card-text class="event-text" v-if="event.text">{{ event.text }}</v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      dense: false,
    };
  },
    computed: {
        timelineData() {
            return [
                {
                    date: "JANUARY 2021 - PRESENT",
                    title: "Frontend Contractor",
                    header:
                        "Working as a contractor on a project for the Polish government.",
                    text: "Creating an online tax office. Developing and team leading the team to create reusable components for the government websites. Delivering new forms for tax office applications."
                },
                {
                    date: "AUGUST 2019 - JANUARY 2021 (1 yr 6 mo)",
                    title: "Frontend Contractor",
                    header:
                        "My first project for a leading pharmaceutical company as a contractor!",
                    text: "Implementing frontend solutions (Vue.js / Vue.js with TypeScript) and testing (Jest) for a leading pharmaceutical company as a contractor."
                },
                {
                    date: "JUNE 2019",
                    title: "Secure and Private AI Challenge Scholarship",
                    header: "Starting a new scholar granted by facebook AI team!",
                    text:
                        "Learning how to apply privacy-preserving tools and techniques to deep learning problems."
                },
                {
                    date: "JANUARY 2019 - present",
                    title: "Billennium S.A.",
                    header:
                        "Starting working for an IT Delivery Centre. Yay! Let the journey begin!",
                    text:
                        "Creating full-stack web applications using Angular 2+, React, Node.js, MongoDB, MySQL, TypeScript, JavaScript (ES6), HTML 5, CSS 3. Building applications using React, Redux, React Hooks, Vue.js, Vuex. Bug fixing and performance optimizations in frontend applications."
                },
                {
                    date: "NOVEMBER 2018",
                    title: "Completing Udacity Frontend Developer Nanodegree",
                    header:
                        "Successfully completing the course along with my Master of Science Degree graduated in July. It’s time to dive into computer science industry! "
                },
                {
                    date: "MARCH 2018",
                    title: "Google's Scholar Phase 2",
                    header:
                        "Winning Frontend Nanodegree sponsored by Google Inc. Finished Phase 1 in top 10% out of 60,000 students!",
                    text:
                        "Learning through the course how to create interactive, fully responsive web applications using  HTML, CSS, vanilla JavaScript, as well as, using object-oriented programming and ES6. Starting using Git for version control. Discovering the basics of automation tools – Gulp and testing the application with Jasmine framework. Getting started working with a modern framework – React."
                },
                {
                    date: "NOVEMBER 2017",
                    title: "Google's Scholar Phase 1",
                    header:
                        "Applying and being selected for the frontend's scholar conducted by Udacity and Google.",
                    text:
                        "Learning basics of vanilla JavaScript, CSS and HTML. Creating my very first web applications!"
                }
            ]
        }
    },
  created() {
    this.onWindowResize();
  },
  methods: {
    onWindowResize() {
      this.dense = window.innerWidth <= 600;
    }
  }
};
</script>
<style lang="scss" scoped>
.experience-section {
  width: 100vw;
  padding: 60px 30px;
  .section-title {
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 3px;
    font-size: 2.5rem;
  }
  .event-header {
    font-size: 1.125rem;
    color: grey;
    font-style: italic;
  }
  .event-text {
    padding: 0 16px 16px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Experience.vue